<template>
  <div v-if="showFeedbackWidget">
    <section
      class="feedback-widget"
      :style="`background: #022245;`"
      :class="{ 'active': show }"
    >
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class=' w-100'

      >
        <vue-resizable
          class="resizable"
          ref="resizableComponent"
          :fit-parent="fit"
          :min-width="minW | checkEmpty"
          :min-height="minH | checkEmpty"
          :max-width="windowWidth | checkEmpty"
          :max-height="windowHeight | checkEmpty"
          :width="width"
          :height="height"
          :left="left"
          :top="top"
          :disableAttributes="['l', 't']"
          @mount="eHandler"
          @resize:move="eHandler"
          @resize:start="eHandler"
          @resize:end="eHandler"
          @drag:move="eHandler"
          @drag:start="eHandler"
          @drag:end="eHandler"
        >
          <section class="resizable-content">
            <section class="mt-2 px-2 " v-if="showFrequentlyAskedQuestions">
              <section class="frequently-asked-questions-body ">
                <p>
                  <b-icon
                    @click="setShowFrequentlyAskedQuestions({}, false)"
                    icon="arrow-left-short"
                    scale="2"
                    class="cursor-pointer"
                  >
                  </b-icon>
                  <strong class="ml-3">{{ frequentlyAskedQuestion.title }}</strong>
                </p>
                <section :style="`height: ${this.height - 150}px`" v-html="frequentlyAskedQuestion.body"></section>
              </section>
            </section>

            <section v-else class="w-100">
              <section v-if="btnNav === ajuda" class="px-3 mt-2 pb-3  ">
              </section>

              <section class="pb-2 pt-2">
                <section v-if="btnNav === inicio">
                  <section class="feedback" :style="`height: ${this.height - 110}px;`" v-if="showToSendFeedBasck">
                    <p>
                      Envie um e-mail informando sua dúvida, crítica ou sugestão para nosso suporte técnico. Estaremos
                      te
                      ajudando o mais rápido possível.
                    </p>

                    <section>
                      <label for="email">E-mails</label>
                      <b-form-input
                        v-model="feedback.email"
                        disabled
                        id="email"
                        placeholder="E-mail"
                      >
                      </b-form-input>
                    </section>

                    <section class="mt-2 ">
                      <section class="input-email-copy">
                        <input v-model="emailCopy" class="form-control w-100" />

                        <b-icon
                          @click="addEmail()"
                          class="ml-2 icon-add cursor-pointer" icon="plus" color="#000000"
                          scale="2"
                        >
                        </b-icon>
                      </section>

                      <section
                        class="input-emails-copy mt-2"
                        v-for="(email, i) in emailsCopy"
                        :key="`${email}_${i}`"
                      >
                        <input v-model="email.email" class="form-control w-100" />
                        <section class="icons">
                          <b-icon @click="removeEmail(i)" class="ml-2 icon-add cursor-pointer" icon="trash"
                                  color='#bc0000'></b-icon>
                          <b-icon @click="addEmail()" class="ml-2 icon-add cursor-pointer" icon="plus" color="#000000"
                                  scale="2"></b-icon>
                        </section>
                      </section>
                    </section>

                    <section class="mt-3">
                      <label>Mensagem</label>
                      <b-form-textarea
                        id="message"
                        v-model="feedback.message"
                        placeholder="Preencha a mensagem aqui"
                        rows="5"
                      ></b-form-textarea>
                    </section>

                    <section class="mt-3">
                      <input
                        type="file"
                        hidden
                        id="files"
                        @change="onChange"
                        multiple
                      />
                      <label class="button-upload cursor-pointer mb-2" for='files'>
                        <span class="mr-2">Anexar fotos ou arquivos</span>
                        <svg width="10" height="15" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.29357 10.707C1.1061 10.5194 1.00078 10.2651 1.00078 9.99997C1.00078 9.73481 1.1061 9.4805 1.29357 9.29297L4.58657 5.99997L1.29357 2.70697C1.19806 2.61472 1.12188 2.50438 1.06947 2.38237C1.01706 2.26037 0.989472 2.12915 0.988319 1.99637C0.987165 1.86359 1.01247 1.73191 1.06275 1.60902C1.11303 1.48612 1.18728 1.37447 1.28117 1.28057C1.37507 1.18668 1.48672 1.11243 1.60961 1.06215C1.73251 1.01187 1.86419 0.986565 1.99697 0.987719C2.12975 0.988872 2.26097 1.01646 2.38297 1.06887C2.50498 1.12128 2.61532 1.19746 2.70757 1.29297L6.70757 5.29297C6.89504 5.4805 7.00036 5.7348 7.00036 5.99997C7.00036 6.26513 6.89504 6.51944 6.70757 6.70697L2.70757 10.707C2.52004 10.8944 2.26573 10.9998 2.00057 10.9998C1.73541 10.9998 1.4811 10.8944 1.29357 10.707Z"
                                fill="#262626" />
                        </svg>
                      </label>

                      <section v-if="files && files.length > 0" class="d-flex flex-wrap">
                        <section
                          class="files"
                          v-for="(file, indexFile) in files"
                          :key="indexFile"
                        >
                <span>
                  {{ file.name }}
                </span>
                          <b-icon icon="x" @click="removeFile(indexFile)" class="cursor-pointer" scale="1.5"
                                  color="#bc0000"></b-icon>
                        </section>
                      </section>

                      <section v-else>
                        <span>Nenhum arquivo selecionado</span>
                      </section>
                    </section>

                    <section class="w-100 mt-2">
                      <b-alert
                        show
                        variant='danger'
                        :class='{ hidden: !errors }'
                      >
                        {{ errors }}
                      </b-alert>
                      <section class="w-100 d-flex justify-content-between">
                        <b-button @click="showToSendFeedBasck = !showToSendFeedBasck" class="btn" variant="danger">
                          Cancelar
                        </b-button>
                        <b-button @click="handleSubmitFeedback()" :disabled="!isValid()" class="btn" variant="success">
                          Enviar
                        </b-button>
                      </section>
                    </section>
                  </section>

                  <section v-else >
                    <section class="suporte">
                      <button>
                        <span @click="showToSendFeedBasck = !showToSendFeedBasck" class="mr-2">Solicitar suporte</span>
                        <svg width="10" height="15" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.29357 10.707C1.1061 10.5194 1.00078 10.2651 1.00078 9.99997C1.00078 9.73481 1.1061 9.4805 1.29357 9.29297L4.58657 5.99997L1.29357 2.70697C1.19806 2.61472 1.12188 2.50438 1.06947 2.38237C1.01706 2.26037 0.989472 2.12915 0.988319 1.99637C0.987165 1.86359 1.01247 1.73191 1.06275 1.60902C1.11303 1.48612 1.18728 1.37447 1.28117 1.28057C1.37507 1.18668 1.48672 1.11243 1.60961 1.06215C1.73251 1.01187 1.86419 0.986565 1.99697 0.987719C2.12975 0.988872 2.26097 1.01646 2.38297 1.06887C2.50498 1.12128 2.61532 1.19746 2.70757 1.29297L6.70757 5.29297C6.89504 5.4805 7.00036 5.7348 7.00036 5.99997C7.00036 6.26513 6.89504 6.51944 6.70757 6.70697L2.70757 10.707C2.52004 10.8944 2.26573 10.9998 2.00057 10.9998C1.73541 10.9998 1.4811 10.8944 1.29357 10.707Z"
                                fill="#262626" />
                        </svg>
                      </button>
                    </section>

                    <section :style="`height: ${this.height - 200}px`" class="frequently-asked-questions mt-2 mx-2">
                      <a @click="btnNav = ajuda"
                         class=" d-flex justify-content-between align-items-center cursor-pointer px-2 pt-3">
                        <span>Qual é a sua dúvida?</span>
                        <svg class="mr-3" width="18" height="18" viewBox="0 0 18 18" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z"
                            fill="#022245" />
                        </svg>
                      </a>

                      <ul class="p-4">
                        <li
                          @click="setShowFrequentlyAskedQuestions(frequentlyAskedQuestion, true)"
                          v-for="frequentlyAskedQuestion in frequentlyAskedQuestions"
                          :key="frequentlyAskedQuestion._id"
                          class="py-2 d-flex justify-content-between align-items-center cursor-pointer"
                        >
                          <strong>{{ frequentlyAskedQuestion.title }}</strong>
                          <b-icon
                            class='ml-3'
                            icon="chevron-right"
                            :id="`${frequentlyAskedQuestion._id}_`"
                            color="#022245"
                          >
                          </b-icon>
                        </li>
                      </ul>
                    </section>
                  </section>
                </section>

                <section class="pb-2 pt-2" v-if="btnNav === chat">
                  <section class="chat p-3">
                    <p>
                      Em breve, você poderá tirar suas dúvidas e receber sugestões diretamente de nosso chat
                      com IA, para uma experiência ainda mais otimizada.
                    </p>
                  </section>
                </section>

                <section class="px-2" v-if="btnNav === ajuda">
                  <b-overlay
                    :show='loadingCategoryFrequentlyAskedQuestions'
                    rounded
                    opacity='0.6'
                    spinner-small
                    spinner-variant='info'
                    class='w-100'

                  >
                    <section :style="`height: ${this.height - 190}px`" class="frequently-asked-questions">
                      <section class="p-2 ml-3 mb-1 d-flex align-items-center" v-if="showFrequentlyAskedQuestionsByCategory">
                        <b-icon
                          @click="setShowFrequentlyAskedQuestionsByCategory({}, false)"
                          icon="arrow-left-short"
                          scale="2.2"
                          class="cursor-pointer"
                        >
                        </b-icon>

                        <p class="ml-2 mb-1"><strong>{{categoryFrequentlyAskedQuestion.name}}</strong></p>
                      </section>

                      <section v-else class="p-2">
                        <b-input-group>
                          <b-form-input
                            placeholder="Pesquisar..."
                            v-model="filterFrequentlyAskedQuestions"
                          >
                          </b-form-input>
                          <b-input-group-append>
                            <b-button variant="outline-info">
                              <b-icon icon="search"></b-icon>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </section>

                      <ul class="px-4" v-if="(filterFrequentlyAskedQuestions && filterFrequentlyAskedQuestions.length >= 3) || showFrequentlyAskedQuestionsByCategory">
                        <li
                          style="list-style: none"
                          class="w-100"
                          v-if="loadingFilterFrequentlyAskedQuestions"
                        >
                          <section class="py-2 d-flex align-content-center justify-content-center">
                            <b-spinner
                              style="width: 1.8rem; height: 1.8rem;"
                              variant="info" label="Spinning"
                            >
                            </b-spinner>
                            <h6 class="ml-2 mt-1"><b>Pesquisando...</b></h6>
                          </section>
                        </li>
                        <li
                          class="py-2 d-flex justify-content-between align-items-center"
                          v-if="loadingCategoryFrequentlyAskedQuestions"
                        >
                        </li>

                        <li
                          v-else
                          @click="setShowFrequentlyAskedQuestions(frequentlyAskedQuestion, true)"
                          v-for="frequentlyAskedQuestion in frequentlyAskedQuestions"
                          :key="frequentlyAskedQuestion._id"
                          class="py-2 d-flex justify-content-between align-items-center cursor-pointer"
                        >
                          <strong>{{ frequentlyAskedQuestion.title }}</strong>
                          <b-icon
                            class='ml-3'
                            icon="chevron-right"
                            :id="`${frequentlyAskedQuestion._id}_`"
                            color="#022245"
                          >
                          </b-icon>
                        </li>

                        <li
                          class="w-100"
                          style="list-style: none"
                          v-if="!loadingFilterFrequentlyAskedQuestions && filterFrequentlyAskedQuestions && (!frequentlyAskedQuestions || frequentlyAskedQuestions.length <= 0)"
                        >

                          <p class="text-center">Nenhuma pergunta encontrada para: {{filterFrequentlyAskedQuestions}}.</p>
                        </li>
                      </ul>

                      <ul class="px-4" v-else>
                        <li
                          @click="setShowFrequentlyAskedQuestionsByCategory(category, true)"
                          v-for="category in categoryFrequentlyAskedQuestions"
                          :key="category._id"
                          class="py-3 d-flex justify-content-between align-items-center cursor-pointer"
                        >
                          <strong>{{ category.name }}</strong>
                          <b-icon
                            class='ml-3'
                            icon="chevron-right"
                            :id="`${category._id}_`"
                            color="#022245"
                          >
                          </b-icon>
                        </li>
                      </ul>
                    </section>

                    <template v-slot:overlay>
                      <div class="text-center loading">
                        <b-spinner style="width: 3rem; height: 3rem;" variant='info'></b-spinner>
                      </div>
                    </template>
                  </b-overlay>
                </section>
              </section>
            </section>

            <section class="footer-content">
              <section class="footer flex-wrap d-flex justify-content-between text-center align-items-end">
                <button @click="setBtnNav(inicio)" class="d-flex flex-column align-items-center">
                  <svg width="38" height="27" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19 0.125L0.25 17H5.875V32H32.125V17H37.75M20.875 28.25H17.125V26.375H20.875M21.8125 21.8375V24.5H16.1875V21.8375C15.1151 21.2184 14.277 20.2627 13.8032 19.1187C13.3293 17.9747 13.2462 16.7063 13.5667 15.5102C13.8872 14.3142 14.5933 13.2573 15.5757 12.5035C16.5581 11.7497 17.7617 11.3411 19 11.3411C20.2383 11.3411 21.4419 11.7497 22.4243 12.5035C23.4067 13.2573 24.1128 14.3142 24.4333 15.5102C24.7538 16.7063 24.6707 17.9747 24.1968 19.1187C23.723 20.2627 22.8849 21.2184 21.8125 21.8375Z"
                      :fill="btnNav === inicio ? '#04A8F3' : '#3F444D'" />
                  </svg>
                  <span class="mt-2">Início</span>
                </button>

                <button @click="setBtnNav(chat)" class="d-flex flex-column align-items-center">
                  <svg width="38" height="30" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M34 0.25H4C1.9375 0.25 0.25 1.9375 0.25 4V26.5C0.25 28.5625 1.9375 30.25 4 30.25H11.5V35.875C11.5 37 12.25 37.75 13.375 37.75H14.3125C14.6875 37.75 15.25 37.5625 15.625 37.1875L22.5625 30.25H34C36.0625 30.25 37.75 28.5625 37.75 26.5V4C37.75 1.9375 36.0625 0.25 34 0.25ZM17.125 20.875H9.625V13L12.0625 7.75H15.8125L13.1875 13.375H17.125V20.875ZM28.375 20.875H20.875V13L23.3125 7.75H27.0625L24.4375 13.375H28.375V20.875Z"
                      :fill="btnNav === chat ? '#04A8F3' : '#3F444D'" />
                  </svg>

                  <span class="mt-2">Chat com IA</span>
                </button>

                <button @click="setBtnNav(ajuda)" class="d-flex flex-column align-items-center">
                  <svg width="34" height="29" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.125 28.25H18.875V24.5H15.125V28.25ZM17 5.75C15.0109 5.75 13.1032 6.54018 11.6967 7.9467C10.2902 9.35322 9.5 11.2609 9.5 13.25H13.25C13.25 12.2554 13.6451 11.3016 14.3484 10.5984C15.0516 9.89509 16.0054 9.5 17 9.5C17.9946 9.5 18.9484 9.89509 19.6516 10.5984C20.3549 11.3016 20.75 12.2554 20.75 13.25C20.75 17 15.125 16.5312 15.125 22.625H18.875C18.875 18.4062 24.5 17.9375 24.5 13.25C24.5 11.2609 23.7098 9.35322 22.3033 7.9467C20.8968 6.54018 18.9891 5.75 17 5.75ZM3.875 0.125H30.125C31.1196 0.125 32.0734 0.520088 32.7766 1.22335C33.4799 1.92661 33.875 2.88044 33.875 3.875V30.125C33.875 31.1196 33.4799 32.0734 32.7766 32.7766C32.0734 33.4799 31.1196 33.875 30.125 33.875H3.875C2.88044 33.875 1.92661 33.4799 1.22335 32.7766C0.520088 32.0734 0.125 31.1196 0.125 30.125V3.875C0.125 2.88044 0.520088 1.92661 1.22335 1.22335C1.92661 0.520088 2.88044 0.125 3.875 0.125Z"
                      :fill="btnNav === ajuda ? '#04A8F3' : '#3F444D'" />
                  </svg>

                  <span class="mt-2">Ajuda</span>
                </button>
              </section>
            </section>
          </section>
        </vue-resizable>
      </b-overlay>

    </section>


    <button class="feedback-trigger" @click="setShow()">
      <b-icon
        icon="chevron-down"
        color="#022245"
        v-if="show"
        scale="1.5"
      >
      </b-icon>

      <svg v-else width="30" height="26" viewBox="0 0 60 36" fill="none" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect x="0.5" y="0.5" width="59" height="35" fill="url(#pattern0_5707_3029)" />
        <defs>
          <pattern id="pattern0_5707_3029" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_5707_3029" transform="matrix(0.00714286 0 0 0.0120408 0 0.042449)" />
          </pattern>
          <image id="image0_5707_3029" width="140" height="76" preserveAspectRatio="none"
                 xlink:href="data:image/png;base64,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" />
        </defs>
      </svg>
    </button>
  </div>
</template>

<script>
import api from '../../utils/api'
import axios from 'axios'
import { mapActions } from 'vuex'
import _ from 'underscore'
import VueResizable from 'vue-resizable'

export default {
  name: 'FeedbackWidget',
  props: {},
  components: { VueResizable },
  async mounted() {
    this.sessionId = localStorage.getItem('sessionId') != 'null'
    if (this.user) {
      this.feedback.email = this.user.username
      await this.getFrequentlyAskedQuestions('')
      await this.categorFrequentlyAskedQuestions()
    }
   this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  data() {
    const tW = 500
    const tH = 500
    return {
      left: `calc( 50% - ${tW / 2}px)`,
      top: `calc(50% - ${tH / 2}px)`,
      height: tH,
      width: tW,
      maxW: 500,
      maxH: 500,
      minW: 300,
      minH: 300,
      fit: false,
      dragSelector: ".drag-container-1, .drag-container-2",
      boxHeight: 500,
      windowHeight: 0,
      windowWidth: 0,
      loadingCategoryFrequentlyAskedQuestions: false,
      startY: 0,
      startHeight: 0,

      boxWidth: 400,
      startX: 0,
      startWidth: 0,
      showToSendFeedBasck: false,
      sessionId: false,
      showFrequentlyAskedQuestions: false,
      frequentlyAskedQuestionsMeta: {},
      frequentlyAskedQuestions: [],
      filterFrequentlyAskedQuestions: null,
      loadingFilterFrequentlyAskedQuestions: false,
      categoryFrequentlyAskedQuestionsMeta: {},
      categoryFrequentlyAskedQuestions: [],
      categoryFrequentlyAskedQuestion: Object,
      frequentlyAskedQuestion: null,
      showFrequentlyAskedQuestionsByCategory: false,
      emailsCopy: [],
      emailCopy: null,
      btnNav: 1,
      inicio: 1,
      chat: 2,
      ajuda: 3,
      feedbackHidden: false,
      show: false,
      loading: false,
      openModal: false,
      feedback: {
        email: '',
        message: '',
        files: [],
        emailsCc: []
      },
      alert: {
        open: false,
        type: 'success',
        message: ''
      },
      files: [],
      MAX_SIZE_IN_BYTES: 1572864
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    errors() {
      return this.$store.getters['access/error']
    },
    showFeedbackWidget() {
      return !['Signin', 'Checkout', 'Signup'].includes(this.$route.name)
    }

  },
  methods: {
    ...mapActions('frequentlyAskedQuestions', {
      handlePagedList: 'handlePagedList'
    }),
    ...mapActions('categoryFrequentlyAskedQuestions', {
      categoryHandlePagedListRelated: 'handlePagedList'
    }),
    ...mapActions('feedback', {
      handleSend: 'handleSend'
    }),
    onResize() {
      this.windowWidth = window.innerWidth * 0.90;
      this.windowHeight = window.innerHeight * 0.87;
    },
    eHandler(data) {
      this.width = data.width
      this.height = data.height
      this.left = data.left
      this.top = data.top
      this.event = data.eventName
    },

    setShowFrequentlyAskedQuestions(frequentlyAskedQuestion, showFrequentlyAskedQuestions) {
      this.showFrequentlyAskedQuestions = showFrequentlyAskedQuestions
      this.frequentlyAskedQuestion = frequentlyAskedQuestion
    },
    async setShowFrequentlyAskedQuestionsByCategory(category, showFrequentlyAskedQuestionsByCategory) {
      this.showFrequentlyAskedQuestionsByCategory = showFrequentlyAskedQuestionsByCategory
      this.categoryFrequentlyAskedQuestion = category
      this.frequentlyAskedQuestionsMeta.limit = 100
      this.frequentlyAskedQuestionsMeta.filter = ''
      this.frequentlyAskedQuestionsMeta.categoryId = category._id
      this.frequentlyAskedQuestionsMeta.skip = 0
      this.loadingCategoryFrequentlyAskedQuestions = true;
      const { meta, data } = await this.handlePagedList({ ...this.frequentlyAskedQuestionsMeta })
      const { itens } = data
      this.frequentlyAskedQuestionsMeta = meta
      this.frequentlyAskedQuestions = itens
      this.loadingCategoryFrequentlyAskedQuestions = false;
    },
    onChange(event) {
      this.files = Array.from(event.target.files)
    },
    setShow() {
      this.show = !this.show
    },
    async setBtnNav(nav) {
      this.btnNav = nav
      if(nav === this.inicio ){
        await this.getFrequentlyAskedQuestions('')
      } else if(nav === this.ajuda && this.filterFrequentlyAskedQuestions){
        await this.getFrequentlyAskedQuestions(this.filterFrequentlyAskedQuestions)
      }
    },
    async getFrequentlyAskedQuestions(filter) {
      this.loading = true
      this.frequentlyAskedQuestionsMeta.limit = 10
      this.frequentlyAskedQuestionsMeta.filter = filter
      this.frequentlyAskedQuestionsMeta.skip = 0
      const { meta, data } = await this.handlePagedList({ ...this.frequentlyAskedQuestionsMeta })
      const { itens } = data
      this.frequentlyAskedQuestionsMeta = meta
      this.frequentlyAskedQuestions = itens
      this.loading = false
    },
    async categorFrequentlyAskedQuestions() {
      this.loadingCategoryFrequentlyAskedQuestions = true
      this.categoryFrequentlyAskedQuestionsMeta.limit = 1000
      this.categoryFrequentlyAskedQuestionsMeta.categoryWithQuestions = true
      const { meta, data } = await this.categoryHandlePagedListRelated({ ...this.categoryFrequentlyAskedQuestionsMeta })
      const { itens } = data
      this.categoryFrequentlyAskedQuestionsMeta = meta
      this.categoryFrequentlyAskedQuestions = itens
      this.loadingCategoryFrequentlyAskedQuestions = false
    },

    async addEmail() {
      if (!this.validEmail(this.emailCopy)) {
        const message = this.emailCopy ? `O E-mail: ${this.emailCopy} 'não é valido!` : `Digite o e-mail!`
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        return
      }

      if (this.emailsCopy && this.emailsCopy.length > 0) {
        for (const email of this.emailsCopy) {
          if (!this.validEmail(email.email.trim())) {
            const message = email.email ? `O E-mail: ${email.email} 'não é valido!` : `Digite o e-mail!`
            this.$bvToast.toast(message, {
              title: 'Atenção',
              variant: 'danger',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 5000
            })
            return
          }
        }
      }
      this.emailsCopy.push({ email: '' })
    },

    removeEmail(index) {
      const indexFind = this.emailsCopy.findIndex(x => x === index)
      this.emailsCopy.splice(indexFind, 1)
    },

    removeFile(index) {
      const indexFind = this.files.findIndex(x => x === index)
      this.files.splice(indexFind, 1)
    },
    validEmail(email) {
      const regexIsEmail = /\S+@\S+\.\S+/
      return regexIsEmail.test(email)
    },
    async handleSubmitFeedback() {
      await this.$store.dispatch('access/updateError', ``)
      const emailsCopy = this.emailsCopy.filter(x => x.email)
      if (this.emailCopy) {
        emailsCopy.unshift({ email: this.emailCopy })
      }

      if (emailsCopy && emailsCopy.length > 0) {
        for (const email of emailsCopy) {
          if (!this.validEmail(email.email.trim())) {
            await this.$store.dispatch('access/updateError', `O E-mail: ${email.email} não é valido!`)
            return
          }
        }
      }

      const emailsCc = emailsCopy.map(x => x.email.trim())
      const fileSizeMAX_SIZE_IN_BYTES = this.files.filter((x) => x.size > this.MAX_SIZE_IN_BYTES)
      if (fileSizeMAX_SIZE_IN_BYTES.length > 0) {
        fileSizeMAX_SIZE_IN_BYTES.forEach((x) => {
          this.$bvToast.toast(`O arquivo ${x.name} é muito grande. O tamanho máximo permitido é ${this.MAX_SIZE_IN_BYTES / 1048576} MB.`, {
            title: 'Aviso',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 7000
          })
        })
        return
      }
      if (this.files.length > 5) {
        this.$bvToast.toast('Màximo de 5 arquivos.', {
          title: 'Aviso',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        return
      }

      this.loading = true
      this.feedback.files = []
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i]

        const { data: responseSignedUrl } = await api.get('uploads/signed-url', {
          params: {
            fileType: file.type
          }
        })

        if (responseSignedUrl.error) {
          return responseSignedUrl
        }

        const { url: signedUrl } = responseSignedUrl
        const url = signedUrl.split('?')[0]

        const options = {
          headers: {
            'Content-Type': file.type
          }
        }
        const uploaded = await axios.put(signedUrl, file, options)
        this.feedback.files.push(
          {
            fileName: this.files[i].name,
            url
          }
        )
      }

      this.feedback.emailsCc = emailsCc
      this.feedback.userId = this.user.id
      this.handleSend(this.feedback)
        .then((res) => {
          const { status, data } = res
          let message = 'Não foi possível enviar seu feedback!'
          let variant = 'danger'
          if (status === 200) {
            message = 'Feedback enviado com sucesso!'
            variant = 'success'
            this.emailsCopy = []
            this.emailCopy = ''
            this.feedback.message = ''
            this.feedback.files = []
            this.files = []
          }

          this.$bvToast.toast(message, {
            title: 'Atenção',
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000
          })

          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.alert.open = true
          this.alert.type = 'danger'
          this.alert.message = 'Erro ao enviar o feedback, tente novamente!'
        })
    },

    closeModal() {
      this.feedback = {
        email: this.feedback.email,
        message: ''
      }
      this.alert = {
        open: false,
        type: 'success',
        message: ''
      }
      this.$emit('close')
    },

    isValid() {
      if (!this.feedback.email || !this.feedback.message) {
        return false
      }

      return true
    }
  },
  filters: {
    checkEmpty(value) {
      return typeof value !== 'number' ? 0 : value
    }
  },
  watch: {
    filterFrequentlyAskedQuestions: _.debounce(async function(newQuery) {
      if (!newQuery || newQuery.length < 3) return
      this.frequentlyAskedQuestionsMeta.limit = 10
      this.frequentlyAskedQuestionsMeta.filter = newQuery
      this.frequentlyAskedQuestionsMeta.skip = 0
      this.loadingFilterFrequentlyAskedQuestions = true
      const { meta, data } = await this.handlePagedList({ ...this.frequentlyAskedQuestionsMeta })
      const { itens } = data
      this.frequentlyAskedQuestionsMeta = meta
      this.frequentlyAskedQuestions = itens
      this.loadingFilterFrequentlyAskedQuestions = false
    }, 1500),
    async show() {
      if (this.show) {
        await this.getFrequentlyAskedQuestions('')
        await this.categorFrequentlyAskedQuestions()
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.resizable-content {
  height: 100%;
  width: 100%;
  background-color: #022245;;
}

.feedback-trigger {
  background: #CBD63E;
  border: 1px solid #04A8F3;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 9999;
  bottom: 15px;
  right: 15px;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feedback-widget {
  position: fixed;
  bottom: 80px;
  right: 20px;
  max-height: 90%;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px) scale(0.98);
  transition: opacity 0.3s ease-out,
  visibility 0.3s linear,
  transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  will-change: opacity, transform;
}

.feedback-widget.active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

.inicio-text {
  color: #262626;
  font-weight: 600;
  font-size: 20px;
}

.suporte {
  box-shadow: 0px -2px 4px 0px #00000040;
  height: 70px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  margin: 0 8px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #022245;
    background: transparent;
    height: 40px;
    width: 80%;
    color: #022245;
    font-weight: 600;
    font-size: 18px;
  }
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;

  .footer {
    background: #FFFFFF;
    box-shadow: 0px -2px 4px 0px #00000040;
    border-radius: 7px 7px 0 0;
    padding: 10px 25px 10px 25px;
    position: absolute !important;
    width: 100%;
    bottom: 0;

    button {
      background: transparent;
      border: none;

      span {
        font-size: 15px;
      }
    }
  }
}

.frequently-asked-questions {
  box-shadow: 0px -2px 4px 0px #00000040;
  background: #FFFFFF;
  border-radius: 7px;
  list-style-type: none;
  //max-height: 300px;
  scrollbar-color: #022245 white;
  scrollbar-width: thin 12px;
  overflow-y: scroll !important;
  overflow-x: hidden !important;


  a {
    text-decoration: none;

    span {
      color: #262626;
      font-weight: 700;
      font-size: 16px;
    }
  }

  strong {
    color: #262626;
    font-weight: 600;
    font-size: 14px;
  }
}


.frequently-asked-questions::-webkit-scrollbar {
  width: 12px;
}

.frequently-asked-questions::-webkit-scrollbar-track {
  background: #ffffff;
}

.frequently-asked-questions::-webkit-scrollbar-thumb {
  background: #022245;
  border: 3px solid #ffffff;
  -webkit-box-shadow: inset 0 0 6px #022245;
}

.feedback::-webkit-scrollbar {
  width: 12px;
}

.feedback::-webkit-scrollbar-track {
  background: #ffffff;
}

.feedback::-webkit-scrollbar-thumb {
  background: #022245;
  border: 3px solid #ffffff;
  -webkit-box-shadow: inset 0 0 6px #022245;
}

.feedback {
  //max-height: 450px;
  box-shadow: 0px -2px 4px 0px #00000040;
  background: #FFFFFF;
  border-radius: 7px;
  margin: 10px 8px 10px 8px;
  padding: 15px;
  scrollbar-color: #022245 white;
  scrollbar-width: thin 12px;
  overflow-y: auto;
  overflow-x: hidden;

  p {
    color: #262626;
    font-weight: 500;
    font-size: 15px;
  }

  .button-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #022245;
    background: transparent;
    height: 40px;
    width: 100%;
    color: #022245;
    font-weight: 600;
    font-size: 18px;
    border-radius: 6.25px;
  }

  .files {
    border: 1px solid #022245;
    border-radius: 5px;
    padding: 5px;
    margin: 4px;
    width: fit-content;
    flex-wrap: wrap;
  }

  .btn {
    width: 49%;
  }

}

.chat {
  box-shadow: 0px -2px 4px 0px #00000040;
  background: #FFFFFF;
  border-radius: 7px;
  margin: 0 8px;
  color: #000000;
  font-weight: 700;
  font-size: 17px;
}

.frequently-asked-questions-body {
  box-shadow: 0px -2px 4px 0px #00000040;
  background: #FFFFFF;
  padding: 10px;
  border-radius: 7px;
  scrollbar-color: #022245 white;
  scrollbar-width: thin 12px;
  overflow-y: auto;
  overflow-x: hidden;
}

.input-email-copy {
  position: relative;

  .icon-add {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.input-emails-copy {
  position: relative;

  .icons {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.box-shadow {
  box-shadow: 0px -2px 4px 0px #00000040;
  background: #FFFFFF;
  margin: 0 8px;
  border-radius: 7px;
}
</style>
